import React, { useState } from 'react';

const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:3001/api';

const EmailVerificationBanner = ({ user, token }) => {
  const [resending, setResending] = useState(false);
  const [message, setMessage] = useState('');

  if (user?.emailVerified) {
    return null; // Don't show banner if email is verified
  }

  const handleResendVerification = async () => {
    setResending(true);
    setMessage('');

    try {
      const response = await fetch(`${API_URL}/auth/resend-verification`, {
        method: 'POST',
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json'
        }
      });

      const data = await response.json();

      if (response.ok) {
        setMessage('✓ Verification email sent! Please check your inbox.');
      } else {
        setMessage(`⚠️ ${data.error || 'Failed to send email'}`);
      }
    } catch (err) {
      setMessage('⚠️ Network error. Please try again.');
    } finally {
      setResending(false);
    }
  };

  return (
    <div style={{
      background: 'linear-gradient(135deg, rgba(239, 68, 68, 0.1) 0%, rgba(220, 38, 38, 0.1) 100%)',
      borderBottom: '2px solid rgba(239, 68, 68, 0.3)',
      padding: '1rem 2rem',
      textAlign: 'center',
      color: 'var(--textSecondary)'
    }}>
      <p style={{ margin: '0 0 0.5rem 0', fontWeight: '600' }}>
        ⚠️ Please verify your email address to access all features
      </p>
      <p style={{ margin: '0', fontSize: '0.9rem' }}>
        Didn't receive the email? 
        <button
          onClick={handleResendVerification}
          disabled={resending}
          style={{
            background: 'none',
            border: 'none',
            color: 'var(--primaryLight)',
            textDecoration: 'underline',
            cursor: 'pointer',
            marginLeft: '0.5rem',
            fontWeight: '600'
          }}
        >
          {resending ? 'Sending...' : 'Resend verification email'}
        </button>
      </p>
      {message && (
        <p style={{ 
          margin: '0.5rem 0 0 0', 
          fontSize: '0.9rem',
          color: message.includes('✓') ? '#86efac' : '#fca5a5'
        }}>
          {message}
        </p>
      )}
    </div>
  );
};

export default EmailVerificationBanner;
